registerComponent("pages/contents-v2-internal", async function (component) {
/**
 * pages/contents-v2-internal — o botão "Copiar link" da barra de compartilhamento.
 *
 * É o único comportamento da página. Os outros três botões de compartilhar são
 * `<a href>` de verdade (LinkedIn, WhatsApp, X) e não precisam de script; o
 * corpo do post é HTML servido pronto.
 *
 * O botão nasce `hidden` no Blade porque copiar é coisa de script: sem JS ele
 * seria um botão que não faz nada. Aqui ele é revelado sempre, porque há dois
 * caminhos para copiar e um deles funciona em qualquer lugar:
 *
 *   1. `navigator.clipboard.writeText` — o caminho moderno, mas só existe em
 *      contexto seguro (https, localhost, arquivo local). Servido em http puro,
 *      como o preview de apresentação, `navigator.clipboard` é `undefined` e o
 *      botão ficava escondido: era o "copiar link que não funciona" (23/09).
 *   2. `document.execCommand('copy')` sobre um `<textarea>` fora da tela — o
 *      truque antigo, obsoleto no papel, mas que todo navegador ainda executa
 *      e que não depende de contexto seguro.
 */

const botao = component.querySelector('.bl-copy');

if (botao) {
    botao.hidden = false;

    const rotuloOriginal = botao.getAttribute('aria-label');
    const rotuloFeito = botao.dataset.feito;
    let temporizador = 0;

    const copiarPeloTextarea = (texto) => {
        const area = document.createElement('textarea');
        area.value = texto;
        area.setAttribute('readonly', '');
        area.style.position = 'fixed';
        area.style.top = '-1000px';
        area.style.opacity = '0';
        document.body.appendChild(area);
        area.select();

        let copiou = false;
        try {
            copiou = document.execCommand('copy');
        } catch (e) {
            copiou = false;
        }

        area.remove();

        return copiou;
    };

    const copiar = async (texto) => {
        if (navigator.clipboard && window.isSecureContext) {
            try {
                await navigator.clipboard.writeText(texto);

                return true;
            } catch (e) {
                // Permissão negada: cai no textarea, que não pede permissão.
            }
        }

        return copiarPeloTextarea(texto);
    };

    botao.addEventListener('click', async () => {
        if (! await copiar(botao.dataset.copiar)) {
            // Nada copiou, e não há o que a pessoa possa resolver — a URL está
            // na barra de endereços. Sai sem confirmar, em vez de mentir com o
            // "copiado".
            return;
        }

        /*
         | A confirmação é o balão dourado (`.is-feito`, desenhado no LESS com
         | o texto de `data-feito`) MAIS o `aria-label`: sem trocar o rótulo
         | acessível, quem usa leitor de tela aperta o botão e não recebe
         | retorno nenhum. O rótulo volta ao original depois, senão o botão
         | passa a se anunciar para sempre como "Copiado".
         */
        botao.classList.add('is-feito');
        botao.setAttribute('aria-label', rotuloFeito);

        Asa.track('share', {
            method: 'copy_link',
            content_type: 'article',
            target_id: window.location.pathname.split('/').filter(Boolean).pop(),
            target_name: document.title.split('|')[0],
        });

        clearTimeout(temporizador);
        temporizador = setTimeout(() => {
            botao.classList.remove('is-feito');
            botao.setAttribute('aria-label', rotuloOriginal);
        }, 2000);
    });
}

/*
 | Tagueamento (plano v3.1): a leitura completa. O fim do corpo à vista E ao
 | menos 30 s na página — mais fiel que `scroll_depth = 100`, que conta o
 | "Continue lendo" e o rodapé junto.
 */
const corpo = component.querySelector('.article__body');

if (corpo && 'IntersectionObserver' in window) {
    const inicio = Date.now();
    const fim = document.createElement('span');

    fim.setAttribute('aria-hidden', 'true');
    corpo.appendChild(fim);

    const avisar = () => Asa.trackUmaVez('leitura', 'article_read', {
        target_id: window.location.pathname.split('/').filter(Boolean).pop(),
        seconds: Math.round((Date.now() - inicio) / 1000),
    });

    const observador = new IntersectionObserver((entradas) => {
        if (!entradas.some((entrada) => entrada.isIntersecting)) return;

        observador.disconnect();

        const falta = 30000 - (Date.now() - inicio);

        if (falta <= 0) avisar();
        else setTimeout(avisar, falta);
    });

    observador.observe(fim);
}

});
